"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSdk = require("@100mslive/react-sdk");
var _reactUi = require("@100mslive/react-ui");
var _Chat = require("../components/Chat/Chat");
var _ParticipantList = require("../components/Header/ParticipantList");
var _StreamingLanding = require("../components/Streaming/StreamingLanding");
var _constants = require("../common/constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var SidePane = function SidePane(_ref) {
  var _ref$css = _ref.css,
    css = _ref$css === void 0 ? {} : _ref$css;
  var sidepane = (0, _reactSdk.useHMSStore)((0, _reactSdk.selectAppData)(_constants.APP_DATA.sidePane));
  var ViewComponent;
  if (sidepane === _constants.SIDE_PANE_OPTIONS.PARTICIPANTS) {
    ViewComponent = _ParticipantList.ParticipantList;
  } else if (sidepane === _constants.SIDE_PANE_OPTIONS.CHAT) {
    ViewComponent = _Chat.Chat;
  } else if (sidepane === _constants.SIDE_PANE_OPTIONS.STREAMING) {
    ViewComponent = _StreamingLanding.StreamingLanding;
  }
  if (!ViewComponent) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
    css: _objectSpread(_objectSpread({
      position: "absolute",
      w: "$100",
      h: "100%",
      p: "$10",
      bg: "$surfaceDefault",
      r: "$1",
      top: 0,
      right: "$10",
      zIndex: 10,
      boxShadow: "$md"
    }, css), {}, {
      "@lg": _objectSpread({
        w: "100%",
        right: 0,
        position: "fixed",
        bottom: 0,
        height: "unset"
      }, css["@lg"] || {})
    }),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ViewComponent, {})
  });
};
var _default = SidePane;
exports["default"] = _default;